import ukGovLogo from "../icons/uk_gov_logo.png";

const UKRibbon = () => {
  return (
    <header>
      <div className="flex bg-black text-white p-2">
        <div className="flex-initial">
          <img className="w-12 h-10" src={ukGovLogo} alt="" />
        </div>
        <div className="truncate flex-initial py-3 sm:py-2 lg:py-2 ml-2">
          <p className="text-xs sm:text-base">
            Department for Environment Food & Rural Affairs
          </p>
        </div>
      </div>
      <div className="border-blue-600 font-bold border-2 " role="region" aria-labelledby="govuk-notification-banner-title" data-module="govuk-notification-banner">
        <p className="p-2 bg-white text-black text-lg">
          Air quality compliance data for the 2025 assessment was       <a className="text-blue-700 hover:text-blue-600 underline" href="https://www.gov.uk/government/publications/air-quality-compliance-assessment-2025-results-and-data-tables">published on GOV.UK</a>. Supporting GIS shapefiles <a className="text-blue-700 hover:text-blue-600 underline" href="https://www.gov.uk/government/publications/air-quality-compliance-assessment-2025-modelled-data-and-reports">are available here</a>.
        </p>
      </div>
    </header>
  );
};

export default UKRibbon;
